<template>
  <div>
    <Button class="bkcc-btn"  @click="saveSend" :loading="saveLoading">保存</Button>
    <Button class="bkcc-btn"  @click="send" >预览</Button>
    <Button class="bkcc-btn"  @click="handleQunfa" :loading="qunfaLoading">群发</Button>
    <Modal
      v-model="showModal"
      title="发送预览"
      :mask-closable="false"
      width="580"
      @on-ok="sendArtical"
      @on-cancel="sendCancel"
      :loading="isloading"
    >
      <div style="color:#333">关注公众号后，才能接收图文消息预览</div>
      <Input
        v-model="sendInput"
        size="large"
        placeholder="可输入多个微信号，用逗号分隔"
        style="padding:20px 0"
        clearable
        @on-enter="inputSend"
      />
      <div style="color: #999">预览功能仅用于公众号查看文章效果，不适用于公众传播，预览链接会在短时间内失效</div>
      <div class="yulan-wrapper">
        <div v-if="sendFalse" class="box">
          <div class="tishi-wrapper">
            <p>1、接收预览消息的微信尚未关注公众号，请先扫码关注</p>
            <p>2、如果已经关注公众号，请查看微信的隐私设置(在手机微信的"我->设置->隐私->添加我的方式"中),并开启"可通过以下方式找到我:"下的"手机号"、"微信号"、"QQ号",否则可能接收不到预览消息</p>
          </div>
          <div class="line"></div>
          <div class="ma-wrapper box box_v">
            <div v-if="!erweimaUrl" class="erweima" style="background: #ddd"></div>
            <img v-else class="erweima" :src="erweimaUrl">
            <div style="margin-left:-15px">扫描关注{{qrcodeName}}</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    articleIdList: {
      type: Array,
      default: () => []
    },
    saveLoading:Boolean,
  },
  data() {
    return {
      showModal: false,
      sendInput: "",
      isloading: true,
      sendFalse: false,
      erweimaUrl: "",
      qrcodeName:'',
      qunfaLoading:false,
    };
  },
  watch: {
    isloading() {
      if (!this.isloading) {
        setTimeout(() => {
          this.isloading = true;
        }, 300);
      }
    }
  },
  methods: {
    saveSend() {
      // console.log(this.articleIdList);
      this.$emit('saveSend',{type:'baocun'})
    },
    send() {
      this.showModal = true;
    },
    sendArtical() {
      if (!this.sendInput) {
        this.isloading = false;
        this.showModal = true;
        this.$Message.warning("请填写预览微信号");
        return;
      }
      this.$emit('saveSend',{type:'yulan'}) // 预览前保存一下
    },
    sendCancel() {
    },
    inputSend() {
    },
    handleQunfa () {
      this.$emit('saveSend',{type:'qunfa'}) // 群发前保存一下
    },
    qunfa () {
      this.qunfaLoading =true
      var url = this.urlobj.sendArtical() + "?articleIdList=" + this.articleIdList
      this.$post(url)
        .then(res => {
          this.qunfaLoading = false
          this.$Message.success("推送成功,请稍后查看发送状态");
          this.showModal = false;
        }).catch(e => {
          this.qunfaLoading = false
      })
    },
    yulan () {
      let reg = /,|，/g;
      var wechatUserId = this.sendInput ? this.sendInput.split(reg) : "";
      var url =
        this.urlobj.sendArtical() +
        "?articleIdList=" +
        this.articleIdList +
        "&wechatUserId=" +
        wechatUserId;
      this.$post(url)
        .then(res => {
            this.$Message.success("推送成功");
            this.showModal = false;
            this.sendFalse = false;
        })
        .catch(e => {
            this.sendFalse = true;
            this.isloading = false;
            var url1 = this.urlobj.erweima;
            this.$get(url1).then(res => {
              this.erweimaUrl = res.rows[0].qrcode_url;
              this.qrcodeName = this.$store.state.GZHname;
            })
        });
    }
  },
};
</script>

<style scoped>
.erweima {
  height: 100px;
  width: 100px;
}
.yulan-wrapper {
  height: 240px;
  padding-top: 20px;
}
.tishi-wrapper {
  flex: 1;
  color: #d12b2b;
  padding-right: 70px;
  font-size: 15px;
}
.ma-wrapper {
  width: 230px;
  align-items: center
  /* padding-left: 90px; */
}
.line {
  border-left: 1px #ddd solid;
  margin-bottom: 60px;
}
</style>
